import React from 'react';
import styled, { css } from 'styled-components';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import useBattlesUnlocked from 'shared/screens/Battles/hooks/useBattlesUnlocked';
import Button from '../../../../components/Button/Button';
import { getText, TEXT_KEY } from 'shared/utils/localization';

const BattlesUnlocked = props => {
  const { battlesAssets, handleBattlesUnlocked, dismissModal } = useBattlesUnlocked(props);

  return (
    <Container $source={battlesAssets?.BATTLES_UNLOCKED}>
      <CloseButton src={assetSource(ASSET_KEY.CLOSE_BUTTON)} onClick={dismissModal} />

      <WrapperButton>
        <MainButton
          label={getText(TEXT_KEY.BATTLES_LEARN_MORE)}
          imageSource={assetSource(ASSET_KEY.ROUNDEDRECT_PRIMARY_WIDE)}
          onClick={handleBattlesUnlocked}
        />
      </WrapperButton>
    </Container>
  );
};

export default BattlesUnlocked;

BattlesUnlocked.hideDefaultBackground = true;
BattlesUnlocked.hideCloseButton = true;
BattlesUnlocked.AsModalProps = {
  dialogClassName: 'gtp-modal-battles-tutorial',
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${({ $source }) => $source});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1;
`;

const CloseButton = styled.img`
  width: 4vw;
  height: 4vw;
  object-fit: contain;
  position: absolute;
  top: -0.75vw;
  right: 14.5vw;
  cursor: pointer;
  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.device('mobile-browser') &&
    `
    right: 19vw;
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.device('mobile-browser') &&
    `
    right: 19.2vw;
    top: -0.6vw;
  `}
`;

const WrapperButton = styled.div`
  position: absolute;
  bottom: 4vw;
  width: 25vw;
  display: flex;
  justify-content: center;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
    bottom: 3vw;
  `}
`;

const MainButton = styled(Button).attrs({
  containerStyle: css`
    position: relative;
    width: 100%;
    ${({ theme }) =>
      theme.screens.device('mobile-browser') &&
      `
    width: 85%;
  `}
  `,
  imageStyle: css`
    width: 100%;
  `,
  textStyle: css`
    font-size: 2vw;
    text-transform: uppercase;
  `,
})``;

